import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { DietCategoryDetailsPage } from './pages'

const DietCategoriesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.DIET_CATEGORIES_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={DietCategoryDetailsPage}
    />
  </Switch>
)

export default DietCategoriesRouter
